import { ThemeProvider } from "@repo/ui/components/theme-provider"
import { createElement } from "react"
import { Route, Routes } from "react-router"

import { dashboardModules } from "@/modules"
import { DashboardLayout } from "@/routes/dashboard-layout"
import { ForgotPasswordPage } from "@/routes/forgot-password"
import { LoginPage } from "@/routes/login"
import { NotFoundPage } from "@/routes/not-found"
import { ProfilePage } from "@/routes/profile"
import { ResetPasswordPage } from "@/routes/reset-password"

export function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route element={<DashboardLayout />}>
          <Route path="/profile" element={<ProfilePage />} />
          {dashboardModules.flatMap((module) =>
            module.routes.map((route) => (
              <Route
                key={`${module.id}:${route.path}`}
                path={route.path}
                element={createElement(route.component)}
              />
            ))
          )}
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ThemeProvider>
  )
}
